(function () {
  function initSection(root) {
    if (!root || root.getAttribute('data-ht-ready')) return;
    root.setAttribute('data-ht-ready', 'true');

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var designMode = window.Shopify && window.Shopify.designMode;

    // En el editor de temas, con movimiento reducido o sin soporte del
    // navegador, se muestra todo directamente (sin animación de entrada).
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) {
      root.classList.add('ht-visible');
      return;
    }

    root.classList.add('ht-js');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          root.classList.add('ht-visible');
          observer.disconnect();
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    observer.observe(root);
  }

  function initAll() {
    document.querySelectorAll('[data-ht-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Al añadir o editar la sección desde el personalizador de Shopify.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target && event.target.querySelector('[data-ht-section]');
    if (root) {
      root.removeAttribute('data-ht-ready');
      initSection(root);
    }
  });
})();